import React from 'react';
function More2({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M12 11a1 1 0 100 2 1 1 0 000-2zM18 11a1 1 0 100 2 1 1 0 000-2zM6 11a1 1 0 100 2 1 1 0 000-2z" />
    </svg>
  );
}

export default More2;
